<template>
  <div class="container rounded-xl bg-white p-2 relative lg:flex-grow flex flex-col space-y-3 h-full">
    <div class="flex flex-col flex-grow lg:h-full overflow-y-auto">
      <div class="flex flex-col lg:flex-row h-full space-y-2 lg:space-y-0 lg:space-x-2">
        <div class="overflow-y-auto flex flex-col space-y-2 flex-grow lg:w-2/3 p-1">
          <order-general :order="order" :payments="payments"
                         :branches="branches" :invoicing_branches="invoicing_branches" :load="load"
                         :update="update" :pv_option="pv_option"></order-general>
          <div class="flex flex-col">
            <label for="po">Riferimento Ordine</label>
            <input type="text" id="po" v-model="po_order"/>
          </div>
          <div class="flex flex-col">
            <label for="notes">Note</label>
            <textarea id="notes" v-model="notes"/>
          </div>
          <div class="container rounded-xl bg-gray-light p-2" v-if="pv_options && pv_options.length">
            <p class="text-gray-dark">Incentivi Fotovoltaico</p>
            <div class="my-1" v-for="opt in pv_options">
              <button class="rounded-xl p-1 pl-2 bg-white w-full text-gray-dark uppercase text-left" :class="{'!bg-primary text-white': ((opt.value === 'skip' && !pv_option) || opt.value === pv_option)}" :id="opt.value" :value="opt.value" @click="pv_option = opt.value">{{ opt.title }}</button>
            </div>
            <div v-if="pv_options && (pv_options.findIndex((i) => i.value === 'single') !== -1)">
              <div>Email contrattuario</div>
              <input type="text" v-model="order.pv_email">
            </div>
          </div>
          <div class="flex space-x-2" v-if="shipments && shipping_policies">
            <button
                class="w-1/2 rounded-xl border p-1 flex flex-col items-center justify-center text-center"
                v-if="Object.keys(shipping_policies).includes('SPLIT')"
                @click="update_shipping_policy(shipping_policies.SPLIT)"
                :class="order.shipping_policy === shipping_policies.SPLIT || Object.keys(shipping_policies).length === 1 ? 'border-primary' : 'border-gray-light'">
              <span class="font-bold text-primary">Al più presto</span>
              <span class="text-gray-dark">Spedisci gli articoli il prima possibile, creando più spedizioni</span>
            </button>
            <button
                class="w-1/2 rounded-xl border p-1 flex flex-col items-center justify-center text-center"
                v-if="Object.keys(shipping_policies).includes('COMBINE')"
                @click="update_shipping_policy(shipping_policies.COMBINE)"
                :class="order.shipping_policy === shipping_policies.COMBINE || Object.keys(shipping_policies).length === 1 ? 'border-primary' : 'border-gray-light'">
              <span class="font-bold text-primary">Unica spedizione</span>
              <span class="text-gray-dark">Spedisci gli articoli insieme in un'unica spedizione</span>
            </button>
          </div>
          <div class="flex flex-col space-y-1 p-1 text-gray-dark" v-if="shipments"
               v-for="shipment in shipments">
            <span class="font-bold text-primary">Spedizione il {{
                shipment.shipping_date
              }}, Totale: {{ shipment.total }}</span>
            <div class="mt-1">
              <table class="w-full text-sm">
                <tr class="text-gray-dark w-full">
                  <th class="text-left">SKU</th>
                  <th class="text-left hidden md:block px-1.5 max-w-[22rem] xl:max-w-full">
                    Descrizione
                  </th>
                  <th class="text-right">Quantità</th>
                  <th class="text-right">Prezzo</th>
                  <th class="text-right">Totale</th>
                </tr>
                <tr v-for="product in  shipment.products">
                  <td class="text-left">{{ product.sku }}</td>
                  <td class="text-left hidden md:block px-1.5 max-w-[22rem] xl:max-w-full overflow-hidden text-ellipsis">
                    {{ product.description }}
                  </td>
                  <td class="text-right">{{ product.quantity }}</td>
                  <td class="text-right flex-grow">{{ product.unit_price }}<span
                      class="text-xs">/{{ product.base_uom }}</span></td>
                  <td class="text-right">{{ product.line_price }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="border rounded-xl p-2 text-white flex flex-col text-gray-dark"
               v-if="unavailable_products && unavailable_products.length">
            <span class="text-md text-error">Attenzione!</span>
            <span class="text-gray-dark">Alcuni articoli non sono più disponibili nella quantità desiderata, pertanto l'ordine è stato modificato come segue:</span>
            <span v-for="un_product in unavailable_products" class="text-gray-dark">
                            <span class="hidden lg:block">La quantità del prodotto con sku <span
                                class="font-bold">{{ un_product.sku }}</span> da {{
                                un_product.requested
                              }}{{ un_product.base_uom }} è stata modificata a {{
                                un_product.available
                              }}{{ un_product.base_uom }}</span>
                            <span class="lg:hidden">Qt.a Prodotto <span class="font-bold">{{ un_product.sku }}</span>: {{
                                un_product.requested
                              }}{{ un_product.base_uom }} -> {{ un_product.available }}{{
                                un_product.base_uom
                              }}</span>
                        </span>
          </div>

        </div>
        <div class="flex-grow lg:w-1/3 p-1">
          <div
              class="flex flex-col rounded-xl bg-gray-light  lg:ml-sm text-gray-dark p-2 space-y-1">
            <span class="text-md font-bold text-primary">{{ order.pricing.total }}</span>
            <span class="flex justify-between">
                            <span class="font-bold">Totale listino</span>
                            <span class="">{{ order.pricing.base_price }}</span>
                        </span>
            <span class="flex justify-between">
                            <span class="font-bold">Sconto applicato</span>
                            <span class="">- {{ order.pricing.customer_discount }}</span>
                        </span>
            <span class="flex justify-between" v-if="order.pricing.extra_discount">
                            <span class="font-bold">{{order.extra_discount_name}}</span>
                            <span class="">- {{ order.pricing.extra_discount }}</span>
                        </span>
            <span class="flex justify-between">
                            <span class="font-bold">Spese di spedizione</span>
                            <span class="">{{ order.pricing.shipping_fee }}</span>
                        </span>
            <span class="flex justify-between">
                            <span class="font-bold">Imponibile</span>
                            <span class="">{{ order.pricing.final_price }}</span>
                        </span>
            <span class="flex justify-between">
                            <span class="font-bold">IVA</span>
                            <span class="">{{ order.pricing.tax }}</span>
                        </span>
          </div>
        </div>
      </div>
    </div>
    <div class="h-sm"></div>
    <div class="block fixed left-0 right-0 bottom-0 z-10  text-gray-dark p-2 m-2">
      <div class="container flex justify-between items-center">
                <span class="underline hover:no-underline text-gray-dark bg-navbar backdrop-blur-sm p-2 hover:text-primary cursor-pointer rounded-xl"
                      @click="sendQuote">Invia Preventivo</span>
        <div class="flex space-x-2">
          <button class="btn btn-error p-2" @click="changeStep(1)">Indietro</button>
          <button class="btn btn-primary p-2" @click="create">Crea</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import OrderGeneral from "./order-general.vue";

export default {
  name: "order-summary",
  components: {OrderGeneral},
  props: {
    order: null,
    changeStep: null,
    update: null,
    load: null,
    payments: null,
    branches: null,
    invoicing_branches: null
  },
  data: () => ({
    unavailable_products: [],
    shipments: null,
    shipping_policies: null,
    notes: null,
    po_order:null,
    pv_options: null,
    pv_option: null,
  }),
  watch: {
    pv_option: async function () {
      if (this.pv_option) {
        await axios.post('/ordini/orders/' + this.$props.order.id + '/pv/apply', {pv_option: this.pv_option});
        this.$props.load();
      }

    }
  },
  mounted() {
    let l = this.$loading.show()
    this.$props.update(false);
    this.init();
    l.hide();
  },
  methods: {
    async update_shipping_policy(policy) {
      if (this.$props.order.shipping_policy !== policy) {
        let l = this.$loading.show();
        this.$props.order.shipping_policy = policy;
        this.unavailable_products = await this.$props.update(false, this.pv_option);
        let response = (await axios.get('/ordini/orders/' + this.$props.order.id + '/shipments', {data: {pv_option: this.pv_option}}));
        this.shipments = response.data.data.shipments;
        this.shipping_policies = response.data.data.shipping_policies;
        this.$props.load();
        l.hide();
      }
    },
    async init() {
      this.unavailable_products = (await axios.post('/ordini/orders/' + this.$props.order.id + '/validate')).data;
      this.pv_options = (await axios.get('/ordini/orders/' + this.$props.order.id + '/pv/options')).data;
      let response = (await axios.get('/ordini/orders/' + this.$props.order.id + '/shipments'));
      this.shipments = response.data.data.shipments;
      this.shipping_policies = response.data.data.shipping_policies;
      this.$props.load();
    },
    async sendOption(value) {
      this.pv_option = value;
      if (value !== 'skip') {
        await axios.post('/ordini/orders/' + this.$props.order.id + '/pv/apply');
      }
      this.pv_options = null;
    },
    async create() {
      let l = this.$loading.show();
      try {
        let response = (await axios.post('/ordini/orders/' + this.$props.order.id + '/upgrade', {
          notes: this.notes,
          customer_code: this.po_order,
          pv_option: this.pv_option,
          pv_email: this.$props.order.pv_email
        })).data;
        if (typeof response === 'number') {
          await this.$router.replace({name: 'orders.show', params: {id: response}});
        } else if (Array.isArray(response)) this.unavailable_products = response;
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
      l.hide();
    },
    async sendQuote() {
      let l = this.$loading.show();
      try {
        (await axios.post('/ordini/orders/' + this.$props.order.id + '/quote', {notes: this.notes}));
        this.$toast.success('Preventivo inviato');
      } catch (e) {
        this.$toast.error('Il cliente non ha utenti associati');
      }
      l.hide();
    }
  }
}
</script>

<style scoped>

</style>
